var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Data } from './data';
import * as moment from 'moment';
var Period = /** @class */ (function (_super) {
    __extends(Period, _super);
    function Period() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "Period";
        return _this;
    }
    Period.isTimeOpen = function (period, time) {
        var startTime = period.startTime;
        var endTime = period.endTime;
        var start = moment(startTime, "HH:mm");
        var end = moment(endTime, "HH:mm");
        if (!start || !end) {
            console.log("invalid start / end, period invalid");
            return false;
        }
        var now = moment(time);
        start.year(now.year());
        start.month(now.month());
        start.dayOfYear(now.dayOfYear());
        end.year(now.year());
        end.month(now.month());
        end.dayOfYear(now.dayOfYear());
        if (end < start) {
            console.log("stepped over time to next day!!!");
            if (now > end) {
                end = end.add(24, 'hours');
            }
            else {
                start = start.add(-24, 'hours');
            }
        }
        var within = Period.between(start, end, now);
        return within;
    };
    Period.between = function (start, end, time) {
        var ms = time.valueOf();
        return ms >= start.valueOf() && ms < end.valueOf();
    };
    return Period;
}(Data));
export { Period };
//# sourceMappingURL=period.js.map